<template>
  <div>
    <br />
    The <b>Detection confidence</b> represents the confidence in the maneuver
    detection mechanism. Noise data in the mean orbital elements could be
    mistaken as small maneuvers contained between two consecutive SP
    ephemerides. For that reason two types of detection confidence are
    considered:
    <br />
    <br />
    <ul>
      <li>
        <b>LOW confidence</b>: When the maneuver is detected from a single file.
      </li>
      <br />
      <li>
        <b>HIGH confidence</b>: When the orbital changes and the associated
        maneuver run on multiple consecutive files.
      </li>
      <br />
    </ul>
  </div>
</template>

<script>
export default {
  name: 'tooltipDetectionStatus'
}
</script>
